import { IndustryKnowledgeFields } from './interface';

export const industryKnowledgeInitialValues: IndustryKnowledgeFields = {
  sectors: [],
};
